module.exports = __webpack_public_path__ + "static/media/fingerprint_PNG24.f653c5c7.png";